import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ApplicationProps, Groups, GroupSignatories } from '../../redux-store/types/api-types';
import { MobileViewDataRow, WebViewDataRow } from '../DataTable';
import { poaAuthorisedheaders } from '../NonIndividualInvestor/Authorised';
import {
  checkIfApplicationIsNonIndividualPOA,
  checkforOtherRelatedPerson,
  isRelatedPersonTypeDirector,
} from '../../utils/utilityFunctions';
import { viewDownloadCell } from '../NonIndividualInvestor/Authorised';
import { documentDetails } from '../investors/documentDetails';
import { formatShortDate } from '../../utils/date';
import { relatedPersonTypeMaster } from '../../utils/constant';
const headers = (relatedPersonType: string) => [
  {
    header: 'Name',
    label: 'name',
    valueGetter: (row: GroupSignatories) =>
      (row.name && row.namePrefix ? row.namePrefix + ' ' : '') + (row.name ? row.name : '') ||
      'N/A',
  },
  {
    header: 'PAN',
    valueGetter: (row: GroupSignatories) => row.pan.toUpperCase() || 'N/A',
  },
  {
    header: 'Email ID',
    valueGetter: (row: GroupSignatories) => row.email || 'N/A',
  },
  {
    header: 'Designation',
    valueGetter: (row: GroupSignatories) => row.designation || 'N/A',
  },
  {
    header: 'Mobile Number',
    valueGetter: (row: GroupSignatories) =>
      row.mobile && row.countryCode ? row.countryCode + '-' + row.mobile : row.mobile || 'N/A',
  },
  {
    header: 'Aadhaar',
    valueGetter: (row: GroupSignatories) => row.aadhaar || 'N/A',
  },
  {
    header: 'CKYC Number',
    valueGetter: (row: GroupSignatories) => row.ckycNo || 'N/A',
  },
  {
    header: 'Father/Spouse Name',
    valueGetter: (row: GroupSignatories) =>
      (row.fatherOrSpouseNamePrefix && row.fatherName ? row.fatherOrSpouseNamePrefix + ' ' : '') +
        (row.fatherName ? row.fatherName : '') || 'N/A',
  },
  {
    header: 'Mother Name',
    valueGetter: (row: GroupSignatories) =>
      (row.motherNamePrefix && row.motherName ? row.motherNamePrefix + ' ' : '') +
        (row.motherName ? row.motherName : '') || 'N/A',
  },
  {
    header: 'Politically Exposed Person (PEP)',
    valueGetter: (row: GroupSignatories) => row.pepStatus || 'N/A',
  },
  {
    header: 'Related Person Type',
    valueGetter: (row: GroupSignatories) =>
      row.relatedPersonType
        ? checkforOtherRelatedPerson(row.relatedPersonType)
          ? row.otherRelatedPersonType
          : relatedPersonTypeMaster[row.relatedPersonType]
        : 'N/A',
  },
  ...(isRelatedPersonTypeDirector(relatedPersonType)
    ? [
        {
          header: 'DIN',
          valueGetter: (row: GroupSignatories) => row.din_uid || 'N/A',
        },
      ]
    : []),
  ...(!isRelatedPersonTypeDirector(relatedPersonType)
    ? [
        {
          header: 'UID',
          valueGetter: (row: GroupSignatories) => row.uid || 'N/A',
        },
      ]
    : []),
  {
    header: 'Date Of Birth',
    valueGetter: (row: GroupSignatories) => formatShortDate(row?.dateOfBirth || '') || 'N/A',
  },
  {
    header: 'Gender',
    valueGetter: (row: GroupSignatories) => row.gender || 'N/A',
  },
  {
    header: 'Nationality',
    valueGetter: (row: GroupSignatories) => row.nationality || 'N/A',
  },
  {
    header: 'Address Line 1',
    valueGetter: (row: GroupSignatories) => row.address1 || 'N/A',
  },
  {
    header: 'Address Line 2',
    valueGetter: (row: GroupSignatories) => row.address2 || 'N/A',
  },
  {
    header: 'Address Line 3',
    valueGetter: (row: GroupSignatories) => row.address3 || 'N/A',
  },
  {
    header: 'City',
    valueGetter: (row: GroupSignatories) => row.city || 'N/A',
  },
  {
    header: 'State',
    valueGetter: (row: GroupSignatories) => row.state || 'N/A',
  },
  {
    header: 'Pincode',
    valueGetter: (row: GroupSignatories) => row.pincode || 'N/A',
  },
  {
    header: 'Country',
    valueGetter: (row: GroupSignatories) => row.country || 'N/A',
  },
];

export default function AuthorizedSignatories({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { groups = [], poaauthorisedsignatories = [], requiredAuthorisedSignatory } = application;
  const [documentData, setDocumentData] = useState<documentDetails[]>([]);
  useEffect(() => {
    groups.forEach((groupData) => {
      groupData.groupsignatories.forEach((signatoryData, index) => {
        signatoryData.groupsignatorydocuments.forEach((documentsData) => {
          if (documentsData.documentType === 'authorised_address_proof_doc') {
            setDocumentData([documentsData]);
            return;
          }
        });
      });
    });
  }, []);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Authorised Signatories
            </Typography>
            {((!checkIfApplicationIsNonIndividualPOA(application) && groups.length === 0) ||
              (checkIfApplicationIsNonIndividualPOA(application) &&
                poaauthorisedsignatories.length === 0)) && (
              <Grid
                xs={12}
                sm={12}
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'common.black',
                  textAlign: 'center',
                  my: 3,
                }}>
                No Authorised Signatories
              </Grid>
            )}
            {checkIfApplicationIsNonIndividualPOA(application) &&
            poaauthorisedsignatories.length > 0 ? (
              <>
                <Grid container pt={3}>
                  <Typography>
                    Total No. of required authorised signatories from this group:{' '}
                    {requiredAuthorisedSignatory}
                  </Typography>
                </Grid>
                <Grid container pt={3}>
                  <Grid xs={12} alignSelf="center">
                    <WebViewDataRow
                      tableData={poaauthorisedsignatories}
                      tableHeader={poaAuthorisedheaders}
                      renderAdditionalRow={false}
                      tableHeaderCustomStyles={{
                        '.MuiTableCell-head': {
                          fontFamily: 'Poppins, sans-serif',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'primary.main',
                        },
                      }}
                      rowCustomStyles={{
                        '.MuiTableCell-root': {
                          py: '8px',
                          overflowWrap: 'anywhere',
                          padding: { xs: '10px', sm: '30px' },
                        },
                      }}
                      tableBodyCustomStyles={{
                        '.MuiTableRow-root': {
                          '&:last-child': {
                            borderBottom: 'none',
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                {groups.map((group, index) => {
                  return (
                    <React.Fragment key={group.id}>
                      <Grid container pt={3}>
                        <Typography>
                          Total No. of required authorised signatories from this group:{' '}
                          {group.threshold}
                        </Typography>
                      </Grid>
                      <Grid container pt={3}>
                        <Grid xs={12} alignSelf="center">
                          {group.groupsignatories
                            .filter((_signatory) => _signatory.isActive)
                            .map((signatory, index) => (
                              <React.Fragment key={signatory.id}>
                                <MobileViewDataRow
                                  index={index}
                                  row={signatory}
                                  key={signatory.id}
                                  tableHeader={headers(signatory.relatedPersonType)}
                                />
                              </React.Fragment>
                            ))}
                          {/* <WebViewDataRow
                            groupIndex={index}
                            tableData={group.groupsignatories.filter(
                              (_signatory) => _signatory.isActive
                            )}
                            tableHeader={[...headers, ...viewDownloadCell(documentData)]}
                            renderAdditionalRow={false}
                            tableHeaderCustomStyles={{
                              '.MuiTableCell-head': {
                                fontFamily: 'Poppins, sans-serif',
                                fontSize: 14,
                                fontWeight: 500,
                                color: 'primary.main',
                              },
                            }}
                            rowCustomStyles={{
                              '.MuiTableCell-root': {
                                py: '8px',
                                overflowWrap: 'anywhere',
                                padding: { xs: '10px', sm: '30px' },
                              },
                            }}
                            tableBodyCustomStyles={{
                              '.MuiTableRow-root': {
                                '&:last-child': {
                                  borderBottom: 'none',
                                },
                              },
                            }}
                          /> */}
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </>
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
